import dayjs from "dayjs";
import "dayjs/locale/es";

const copFormatter = new Intl.NumberFormat("es-CO", {
  style: "currency",
  currency: "COP",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const formatCOP = (value: number): string => copFormatter.format(value);

export const formatUSD = (value: number): string => usdFormatter.format(value);

export const formatDateSpanish = (date: string): string => {
  const formatted = dayjs(date).locale("es").format("dddd D [de] MMMM [de] YYYY");
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

export const calculateDiscountedPrice = (price: number, discount: number): number =>
  discount > 0 ? Math.round(price * (1 - discount / 100)) : price;

export const getCurrentDate = (): string => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
